import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class TypeIdService {
  static ENDPOINT = `${BASE}/typeId`;

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      auth: false
    })
  }
}

export default TypeIdService;
